













import Vue from 'vue';
import { defineComponent, PropType } from 'vue';

import i18n from 'src/translate/lang';
import { required } from 'src/validators/validators';

import ListInput from './list-input.vue';

export default defineComponent({
  name: 'ListInputTime',
  components: { ListInput },
  props: {
    required: {
      type: Boolean as PropType<boolean>,
      default: () => false,
    },
    showError: Boolean as PropType<boolean>,
    value: null,
    label: {
      type: String as PropType<string>,
      default: () => i18n.t('global.fields.time.label'),
    },
  },
  data: () => ({
    validationParams: {
      $autoDirty: true,
    } as any,
  }),
  watch: {
    required: {
      handler(value: boolean) {
        if (value) {
          this.validationParams.required = required;
        } else {
          Vue.delete(this.validationParams, 'required');
        }
      },
      immediate: true,
    },
  },
});
